"use client";
import React from "react";
import Error404 from "../src/components/Error404/Error404";
import SingleColumnLayout from "@components/Layout/SingleColumnLayout";
import { useAppContext } from "@components/Provider";

//Component for handeling error on nested pages if error.js is not defined for those page(s)
const error = (message) => {
  const { siteId } = useAppContext();
  return (
    <SingleColumnLayout siteId={siteId}>
      <Error404 error={message} isNewAppRouter={true} />
    </SingleColumnLayout>
  );
};

export default error;
